import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Box, Container, Paper, Typography } from '@mui/material';
import { Gavel } from '@mui/icons-material';
import ClientDisputeManager from '../components/disputes/ClientDisputeManager';
import ContractorDisputeManager from '../components/disputes/ContractorDisputeManager';
import AdminDisputeDashboard from '../components/AdminDisputeDashboard';
import api from '../services/api';

/**
 * Disputes Page
 * Routes users to the appropriate dispute interface based on their role
 */
const DisputesPage = () => {
  const { user } = useAuth();

  const apiClient = api;

  if (!user) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h6">Please log in to view disputes</Typography>
        </Paper>
      </Container>
    );
  }

  const renderDisputeInterface = () => {
    switch (user.role?.toLowerCase()) {
      case 'client':
        return <ClientDisputeManager apiClient={apiClient} />;
      
      case 'contractor':
        return <ContractorDisputeManager apiClient={apiClient} />;
      
      case 'admin':
        return <AdminDisputeDashboard apiClient={apiClient} />;
      
      default:
        return (
          <Paper sx={{ p: 4, textAlign: 'center' }}>
            <Gavel sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
            <Typography variant="h6" gutterBottom>
              Dispute Management Not Available
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Your role ({user.role}) does not have access to dispute management.
            </Typography>
          </Paper>
        );
    }
  };

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
      <Container maxWidth="xl" sx={{ py: 4 }}>
        {renderDisputeInterface()}
      </Container>
    </Box>
  );
};

export default DisputesPage;

